module.exports = __webpack_public_path__ + "img/sideicon3.8a6244cf.png";